import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'avd-code-example-header',
    standalone: true,
    templateUrl: './code-example-header.component.html',
    styleUrls: ['./code-example-header.component.scss'],
    imports: [CommonModule, RouterLink],
})
export class CodeExampleHeaderComponent {
    @Input() packageName: string = '';
    @Input() getStartedLink?: string;
    @Input() storybookLink?: string;
    @Input() repoLink?: string;
}
